import React from 'react';
import styles from "./HocSinhNameAndAvavtar.module.css"
const HocSinhNameAndAvavtar = ({ hocSinh }) => {
    return (
        <div className={styles.container}>
            <div className={styles.avatar}>
                <div style={{
                    background: `url(${hocSinh?.avatar ? hocSinh?.avatar : '../../../images/no-image.png'})`,
                    width: 50,
                    height: 50
                }}>

                </div>
                {/* <img src={`${hocSinh?.avatar ? hocSinh?.avatar : '../../../images/no-image.webp'}`} /> */}
            </div>
            <div className={styles.info}>
                <div className={styles.ho_ten}>{hocSinh?.ho_ten}</div>
                <div className={styles.ma_hs}>{hocSinh?.ma_hs ? hocSinh?.ma_hs : hocSinh?.ma_tn}</div>
            </div>
        </div>
    );
};

export default HocSinhNameAndAvavtar;